export default __webpack_public_path__ + "static/media/ramanamma@2x.e34e8420.png";